import { Component, OnInit } from '@angular/core';
import { AngazovanjeRo } from './angazovanje-ro';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-angazovanje-ro-anex-modal-update',
  templateUrl: './angazovanje-ro-anex-modal-update.component.html'
})
export class AngazovanjeRoAnexModalUpdateComponent
extends BaseModalUpdateComponent<AngazovanjeRo>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<AngazovanjeRo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
